;(() => {
  // Quiz state
  let currentStep = 0
  let formData = {
    name: "",
    surname: "",
    gender: "",
    email: "",
    answers: [],
    currentQuestionIndex: 0,
  }

  // Quiz questions
  const questions = [
    {
      text: "¿Cuáles de estos problemas de salud te afecta más a menudo?",
      options: [
        {
          text: "Siento cansancio constante y falta de energía y vitalidad.",
          plan: "Plan Energise & Focus",
        },
        {
          text: "Mi metabolismo es lento y, aunque haga ejercicio, no logro perder peso fácilmente.",
          plan: "Plan Boost & Burn",
        },
        {
          text: "Tengo la piel apagada, desequilibrada y me preocupan los signos del envejecimiento.",
          plan: "Plan Radiant Skin",
        },
        {
          text: "Sufro de malas digestiones, hinchazón frecuente, y/o gases y dolor abdominal.",
          plan: "Plan Better Digestion",
        },
        {
          text: "No consigo descansar bien, me despierto varias veces durante la noche o me cuesta mucho conciliar el sueño.",
          plan: "Plan Deep Sleep",
        },
        {
          text: "Mi nivel de estrés es muy alto, siento ansiedad, y mis emociones varían constantemente.",
          plan: "Plan De-stress Body & Mind",
        },
        {
          text: "Tengo retención de liquidos e hinchazón y siento que mi cuerpo necesita un detox.",
          plan: "Plan Purifying Detox",
        },
      ],
    },
    {
      text: "¿Cómo te afectan estos problemas en tu vida diaria?",
      options: [
        {
          text: "El cansancio constante afecta mi productividad y estado de ánimo.",
          plan: "Plan Energise & Focus",
        },
        {
          text: "Es frustrante no ver resultados incluso cuando hago deporte y cuido la alimentación.",
          plan: "Plan Boost & Burn",
        },
        {
          text: "Lucir una piel saludable me ayudaría a tener mayor autoestima.",
          plan: "Plan Radiant Skin",
        },
        {
          text: "Las molestias digestivas son frecuentes y me dificultan disfrutar de las comidas o realizar actividades.",
          plan: "Plan Better Digestion",
        },
        {
          text: "La falta de sueño y cansancio constante afectan a mi rendimiento diario y estado de ánimo.",
          plan: "Plan Deep Sleep",
        },
        {
          text: "El estrés diario interfiere con mi bienestar emocional y mental.",
          plan: "Plan De-stress Body & Mind",
        },
        {
          text: "La retención de líquidos e hinchazón constante me impiden sentirme a gusto fisicamente.",
          plan: "Plan Purifying Detox",
        },
      ],
    },
    {
      text: "¿Qué aspecto de tu salud te gustaría mejorar primero?",
      options: [
        { text: "Necesito mejorar mi energía y vitalidad.", plan: "Plan Energise & Focus" },
        { text: "Quiero perder peso de manera efectiva y saludable.", plan: "Plan Boost & Burn" },
        {
          text: "Me gustaría mejorar la apariencia de mi piel y prevenir el envejecimiento.",
          plan: "Plan Radiant Skin",
        },
        {
          text: "Quiero mejorar mi salud digestiva y eliminar los malestares que afectan a mi bienestar diario.",
          plan: "Plan Better Digestion",
        },
        { text: "Quiero descansar mejor para tener más energía y vitalidad.", plan: "Plan Deep Sleep" },
        {
          text: "Necesito reducir mis niveles de estrés para afrontar el día con más calma.",
          plan: "Plan De-stress Body & Mind",
        },
        { text: "Quiero reducir la hinchazón y mejorar mi bienestar general.", plan: "Plan Purifying Detox" },
      ],
    },
  ]

  // Styles
  const styles = `
    #wellness-quiz-modal {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999;
    }

    #wellness-quiz-container {
      background-color: white;
      width: 90%;
      max-width: 800px;
      border-radius: 24px;
      overflow: hidden;
      position: relative;
      max-height: 90vh;
      display: flex;
      flex-direction: column;
    }

    #wellness-quiz-header {
      height: 156px;
      background-image: url('https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Rectangle%206-1Kpb4vmifIteot92KZkTdSeDTuABYh.png');
      background-size: cover;
      background-position: center;
    }

    #wellness-quiz-close {
      position: absolute;
      top: 16px;
      right: 16px;
      background: none;
      border: none;
      font-size: 24px;
      cursor: pointer;
      color: #0e0e0e;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      transition: background-color 0.3s;
      z-index: 10;
    }

    #wellness-quiz-close:hover {
      background-color: rgba(0, 0, 0, 0.1);
    }

    #wellness-quiz-content {
      padding: 40px;
      overflow-y: auto;
      flex-grow: 1;
      background-color: #f9f9f9;
    }

    #wellness-quiz-content h1 {
      font-family: var(--font-fraunces, serif);
      font-size: 32px;
      text-align: center;
      color: #0e0e0e;
      margin-bottom: 16px;
      line-height: 1.2;
    }

    @media (min-width: 768px) {
      #wellness-quiz-content h1 {
        font-size: 40px;
      }
    }

    #wellness-quiz-content p {
      text-align: center;
      color: #0e0e0e;
      margin-bottom: 32px;
      font-size: 18px;
    }

    .quiz-form {
      display: grid;
      gap: 20px;
      background-color: white;
      padding: 32px;
      border-radius: 24px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    }

    .quiz-form input,
    .quiz-form select {
      width: 100%;
      padding: 16px 24px;
      border: 1px solid #E2E2E2;
      border-radius: 100px;
      font-size: 16px;
      outline: none;
      transition: border-color 0.3s;
    }

    .quiz-form input:focus,
    .quiz-form select:focus {
      border-color: #0e0e0e;
    }

    .quiz-form select {
      appearance: none;
      background-image: url("data:image/svg+xml,%3Csvg width='14' height='8' viewBox='0 0 14 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L7 7L13 1' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: right 24px center;
      padding-right: 48px;
    }

    .quiz-button {
      background-color: #0e0e0e;
      color: white;
      border: none;
      border-radius: 100px;
      padding: 16px 32px;
      font-size: 16px;
      cursor: pointer;
      transition: background-color 0.3s;
      width: 100%;
      margin-top: 16px;
    }

    .quiz-button:hover {
      background-color: #2a2a2a;
    }

    .quiz-button:disabled {
      background-color: #cccccc;
      cursor: not-allowed;
    }

    .quiz-options {
      display: grid;
      gap: 16px;
    }

    .quiz-option {
      padding: 24px;
      border: 1px solid #E2E2E2;
      border-radius: 24px;
      cursor: pointer;
      transition: all 0.3s;
      background-color: white;
    }

    .quiz-option:hover {
      background-color: #f4f4f4;
      transform: translateY(-2px);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    }

    .quiz-option.selected {
      border-color: #0e0e0e;
      background-color: white;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    }

    .quiz-progress {
      display: flex;
      justify-content: center;
      gap: 12px;
      background-color: white;
      padding: 16px;
      border-radius: 100px;
      margin-bottom: 32px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    }

    .quiz-progress-dot {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #E2E2E2;
    }

    .quiz-progress-dot.active {
      background-color: #0e0e0e;
    }

    .quiz-navigation {
      display: flex;
      justify-content: space-between;
      padding: 20px 40px;
      background-color: white;
      border-top: 1px solid #E2E2E2;
      box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);
    }

    @media (min-width: 768px) {
      .quiz-form {
        grid-template-columns: repeat(2, 1fr);
      }

      .quiz-form .full-width {
        grid-column: span 2;
      }
    }

    .quiz-form input[type="checkbox"] {
      width: auto;
      margin-right: 8px;
      cursor: pointer;
    }

    .privacy-policy-container {
      display: flex;
      align-items: flex-start;
      margin-top: 16px;
      gap: 8px;
    }

    .privacy-policy-container label {
      font-size: 14px;
      line-height: 1.4;
      color: #666;
    }

    .privacy-policy-container a {
      color: #0e0e0e;
      text-decoration: underline;
    }

    .privacy-policy-container a:hover {
      color: #2a2a2a;
    }
  `

  // Create and append style element
  const styleElement = document.createElement("style")
  styleElement.textContent = styles
  document.head.appendChild(styleElement)

  // Helper function to change text based on gender
  function getGenderedText(text, gender) {
    switch (gender) {
      case "mujer":
        return text.replace(/x/g, "a")
      case "hombre":
        return text.replace(/x/g, "o")
      default:
        return text
    }
  }

  // Create quiz modal
  function createQuizModal() {
    const modal = document.createElement("div")
    modal.id = "wellness-quiz-modal"
    modal.style.display = "none"

    modal.innerHTML = `
      <div id="wellness-quiz-container">
        <div id="wellness-quiz-header"></div>
        <button id="wellness-quiz-close">&times;</button>
        <div id="wellness-quiz-content"></div>
      </div>
    `

    document.body.appendChild(modal)

    // Add event listeners
    const closeButton = modal.querySelector("#wellness-quiz-close")
    closeButton.addEventListener("click", () => {
      modal.style.display = "none"
    })

    // Close on click outside
    modal.addEventListener("click", (e) => {
      if (e.target === modal) {
        modal.style.display = "none"
      }
    })

    return modal
  }

  // Render functions for each step
  function renderStep1() {
    return `
      <h1>DÉJANOS QUE TE CONOZCAMOS UN POCO MEJOR</h1>
      <p>Descubre cuál es el plan que mejor se adapta a tus necesidades</p>
      <form class="quiz-form" id="quiz-form">
        <input type="text" placeholder="Nombre" name="name" required value="${formData.name}">
        <input type="text" placeholder="Apellidos" name="surname" required value="${formData.surname}">
        <select class="full-width" name="gender" required>
          <option value="" ${!formData.gender ? "selected" : ""}>Género</option>
          <option value="mujer" ${formData.gender === "mujer" ? "selected" : ""}>Mujer</option>
          <option value="hombre" ${formData.gender === "hombre" ? "selected" : ""}>Hombre</option>
          <option value="otro" ${formData.gender === "otro" ? "selected" : ""}>Prefiero no especificarlo</option>
        </select>
        <input type="email" placeholder="Email" name="email" class="full-width" required value="${formData.email}">
        <div class="privacy-policy-container full-width">
          <input type="checkbox" id="privacy-policy" name="privacyPolicy" required>
          <label for="privacy-policy">
            He leído y acepto la <a href="https://nattan.life/pages/aviso-legal-y-politica-de-privacidad" target="_blank">política de privacidad</a>
          </label>
        </div>
        <button type="submit" class="quiz-button full-width">Vamos a ver cómo te sientes</button>
      </form>
    `
  }

  function renderStep2(questionIndex) {
    const question = questions[questionIndex]
    return `
      <div class="quiz-progress">
        ${questions
          .map(
            (_, index) => `
          <div class="quiz-progress-dot ${index === questionIndex ? "active" : ""}"></div>
        `,
          )
          .join("")}
      </div>
      <h2 style="font-size: 24px; text-align: center; margin-bottom: 32px;">${question.text}</h2>
      <div class="quiz-options">
        ${question.options
          .map(
            (option, index) => `
          <div class="quiz-option ${formData.answers[questionIndex] === option.plan ? "selected" : ""}" data-plan="${
            option.plan
          }">
            ${getGenderedText(option.text, formData.gender)}
          </div>
        `,
          )
          .join("")}
      </div>
    `
  }

  function renderStep3() {
    return `
      <h1>¡Te esperamos en tu bandeja de entrada!</h1>
      <p>#UnlockNature</p>
      <p>Procesando tus respuestas...</p>
    `
  }

  // Render current step
  function renderCurrentStep() {
    const content = document.getElementById("wellness-quiz-content")
    const container = document.getElementById("wellness-quiz-container")

    content.innerHTML = ""
    if (container.querySelector(".quiz-navigation")) {
      container.querySelector(".quiz-navigation").remove()
    }

    switch (currentStep) {
      case 0:
        content.innerHTML = renderStep1()
        setupStep1Listeners()
        break
      case 1:
        content.innerHTML = renderStep2(formData.currentQuestionIndex || 0)
        setupStep2Listeners()
        break
      case 2:
        content.innerHTML = renderStep3()
        handleQuizSubmit()
        break
    }
  }

  // Setup listeners for each step
  function setupStep1Listeners() {
    const form = document.getElementById("quiz-form")
    form.addEventListener("submit", (e) => {
      e.preventDefault()
      updateFormData()
      if (validateStep1()) {
        currentStep = 1
        formData.currentQuestionIndex = 0
        formData.answers = []
        renderCurrentStep()
      }
    })
  }

  function updateFormData() {
    const form = document.getElementById("quiz-form")
    formData = {
      ...formData,
      name: form.elements.name.value,
      surname: form.elements.surname.value,
      gender: form.elements.gender.value,
      email: form.elements.email.value,
      privacyPolicyAccepted: form.elements.privacyPolicy.checked,
    }
  }

  function validateStep1() {
    const form = document.getElementById("quiz-form")
    return form.checkValidity()
  }

  function setupStep2Listeners() {
    const options = document.querySelectorAll(".quiz-option")
    options.forEach((option) => {
      option.addEventListener("click", () => {
        options.forEach((opt) => opt.classList.remove("selected"))
        option.classList.add("selected")
        const plan = option.dataset.plan
        formData.answers[formData.currentQuestionIndex] = plan

        if (formData.currentQuestionIndex < questions.length - 1) {
          formData.currentQuestionIndex++
          renderCurrentStep()
        } else {
          currentStep = 2
          renderCurrentStep()
        }
      })
    })
  }

  // Quiz submission handler
  async function handleQuizSubmit() {
    try {
      console.log("Starting quiz submission...")
      const recommendedPlan = formData.answers[formData.answers.length - 1]
      const recommendedTag = `quiz_${recommendedPlan.toLowerCase().replace(/\s+/g, "_")}`

      const submitData = {
        ...formData,
        recommendedPlan,
        recommendedTag,
      }

      console.log("Prepared submit data:", JSON.stringify(submitData, null, 2))

      const apiUrl = "https://quizrun-1050921918079.us-central1.run.app/api/submit-quiz"
      console.log("Sending request to:", apiUrl)

      let response
      try {
        response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(submitData),
          mode: "cors",
        })
      } catch (fetchError) {
        console.error("Fetch error:", fetchError)
        throw new Error(`Network error: ${fetchError.message}`)
      }

      console.log("Response status:", response.status)
      console.log("Response headers:", JSON.stringify(Object.fromEntries(response.headers.entries()), null, 2))

      let responseText
      try {
        responseText = await response.text()
        console.log("Raw response:", responseText)
      } catch (textError) {
        console.error("Error reading response text:", textError)
        throw new Error(`Error reading response: ${textError.message}`)
      }

      let data
      try {
        data = JSON.parse(responseText)
        console.log("Parsed response data:", JSON.stringify(data, null, 2))
      } catch (parseError) {
        console.error("Error parsing response:", parseError)
        throw new Error(`Invalid JSON response: ${responseText}`)
      }

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}, message: ${data.error || "Unknown error"}`)
      }

      if (data.message === "Quiz submitted successfully!") {
        document.getElementById("wellness-quiz-content").innerHTML = `
          <h1>¡Gracias por completar el quiz!</h1>
          <p style="color: green;">Tus respuestas han sido enviadas con éxito. Te contactaremos pronto.</p>
        `

        setTimeout(() => {
          document.getElementById("wellness-quiz-modal").style.display = "none"
        }, 10000) // Close after 10 seconds
      } else {
        throw new Error("Unexpected response from server")
      }
    } catch (error) {
      console.error("Error submitting quiz:", error)
      console.error("Error details:", {
        message: error.message,
        stack: error.stack,
        name: error.name,
        cause: error.cause,
      })
      document.getElementById("wellness-quiz-content").innerHTML = `
        <h1>Lo sentimos</h1>
        <p style="color: red;">Hubo un problema al enviar tus respuestas. Por favor, inténtalo de nuevo más tarde.</p>
        <p style="color: red;">Error: ${error.message}</p>
        <button onclick="window.location.reload()" class="quiz-button">Volver a intentar</button>
      `
    }
  }

  // Create the modal when the script loads
  const quizModal = createQuizModal()

  // Initialize the quiz
  function initWellnessQuiz(selector) {
    const triggers = document.querySelectorAll(selector)
    triggers.forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault()
        currentStep = 0
        formData = {
          name: "",
          surname: "",
          gender: "",
          email: "",
          answers: [],
          currentQuestionIndex: 0,
        }
        quizModal.style.display = "flex"
        renderCurrentStep()
      })
    })
  }

  // Expose necessary functions to the global scope
  window.initWellnessQuiz = initWellnessQuiz
})()

